import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../base/hooks";
import { IDropdownPageProps } from "./IDropdownPageProps";

export const DropdownPageProperties = [
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.PageLink, name: 'Page Link', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useDropdownPageProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IDropdownPageProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;
    
        const attributes: IDropdownPageProps = {
            title: bindings.getValue(Property.Tooltip),
            label: bindings.getValue(Property.Label),
            icon: bindings.getValue(Property.MaterialIcon),
            pageLink: bindings.getValue(Property.PageLink)
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
